import SvgIcon from '../../SvgIcon/SvgIcon';
import CustomerRegistrationPopup from '../../Customer/CustomerRegistrationPopup';
import { useCustomer } from '../../../hooks/useCustomer';

interface Props {
  onCustomerCreated?: () => void | Promise<void>;
  onReload?: () => void;
  message?: string;
}

const QuickAddCustomer: React.FC<Props> = ({
  onCustomerCreated,
  onReload,
  message = '¿No encuentras al cliente? Puedes agregar uno nuevo.',
}) => {
  const { showRegistrationModal, openAddModal, closeAddModal } = useCustomer();

  return (
    <div
      className="
        mt-1 flex flex-col gap-2
        sm:flex-row sm:items-center sm:justify-between
      "
    >
      {/* Mensaje contextual */}
      <p className="text-gray-600 dark:text-gray-300 text-xs">{message}</p>

      {/* Botones */}
      <div className="flex items-center gap-2">
        {/* ✅ Verde — Recargar */}
        <button
          onClick={onReload}
          type="button"
          className="
            inline-flex items-center gap-1 rounded
            bg-[#3CA745] px-2 py-1 text-xs font-medium text-white
            transition hover:bg-opacity-90
          "
        >
          <SvgIcon name="refresh" className="h-3 w-3" />
          Recargar
        </button>

        {/* ✅ Azul — Nuevo Cliente */}
        <button
          onClick={openAddModal}
          type="button"
          className="
            inline-flex items-center gap-1 rounded
            bg-primary px-2 py-1 text-xs font-medium text-white
            transition hover:bg-opacity-90
          "
        >
          <SvgIcon name="plus" className="h-3 w-3" />
          Nuevo
        </button>
      </div>

      {/* Popup Modal */}
      <CustomerRegistrationPopup
        isOpen={showRegistrationModal}
        onClose={closeAddModal}
        onSubmit={onCustomerCreated}
      />
    </div>
  );
};

export default QuickAddCustomer;
